import { render, staticRenderFns } from "./MyForm.vue?vue&type=template&id=54955b9a&scoped=true&"
import script from "./MyForm.vue?vue&type=script&lang=js&"
export * from "./MyForm.vue?vue&type=script&lang=js&"
import style0 from "./MyForm.vue?vue&type=style&index=0&id=54955b9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54955b9a",
  null
  
)

export default component.exports